import {
  CustomTargetsDataFragmentFragment,
  StripeBillingInterval,
} from '@/__generated__/graphql.ts';

export type StepperPrice = {
  amount: number;
  interval: StripeBillingInterval;
  intervalCount: number;
};

export const getInitialTargetsCount = (
  customTargets: Pick<
    CustomTargetsDataFragmentFragment,
    'minTargets' | 'stepSize'
  >,
) => {
  const baseValue =
    customTargets.stepSize > customTargets.minTargets
      ? customTargets.stepSize
      : customTargets.minTargets;

  if (baseValue % customTargets.stepSize !== 0) {
    return (
      Math.ceil(baseValue / customTargets.stepSize) * customTargets.stepSize
    );
  }

  return baseValue;
};

export const getNextValidTargetsCount = (
  currentCount: number,
  customTargets: Pick<
    CustomTargetsDataFragmentFragment,
    'minTargets' | 'stepSize'
  >,
) => {
  const floor = Math.max(currentCount + 1, customTargets.minTargets);
  return Math.ceil(floor / customTargets.stepSize) * customTargets.stepSize;
};
